import { render, staticRenderFns } from "./MainTabBar.vue?vue&type=template&id=a3380ede&scoped=true"
import script from "./MainTabBar.vue?vue&type=script&lang=js"
export * from "./MainTabBar.vue?vue&type=script&lang=js"
import style0 from "./MainTabBar.vue?vue&type=style&index=0&id=a3380ede&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3380ede",
  null
  
)

export default component.exports